import { useTranslation } from 'react-i18next';
import TitleBar from '../utils/TitleBar.js';

function Air(props) {
    const { t } = useTranslation();
    const { data } = props;

    let EvaporatorSensorFault = "-";
    let CabTempHumSensorFault = "-";
    let CabinetHighHumAlarm = "-";
    let CabinetHighTempAlarm = "-";
    let CabinetLowTempAlarm = "-";
    let HighPressureAlarm = "-";
    let LackOrLeakageFluorine = "-";
    let CompressorRelay = "-";
    let HeatingRelay = "-";
    let FanRelay = "-";
    let VentilationRelay = "-";
    let SystemOnOff = "-";
    let CabinetTemperature = "-";
    let CabinetHumidity = "-";
    if (data && data.CoilData) {
        let coilData = data.CoilData.map((v) => v.toString(16).padStart(2,"0")).join("");
        let registerData = data.RegisterData.map((v) => v.toString(16).padStart(2,"0")).join("");
        if(coilData && coilData.length >= 4) {
            //'800a' => 128 10 => '0000000101010000'
            const v1 = parseInt('0x'+coilData.slice(0, 2)).toString(2).padStart(8, '0').split('').reverse().join('');
            const v2 = parseInt('0x'+coilData.slice(2, 4)).toString(2).padStart(8, '0').split('').reverse().join('');
            const vs = v1 + v2;

            //对vs的每个bit进行处理
            EvaporatorSensorFault = vs[0] == 0 ? t('Normal') : t('Fault')
            CabTempHumSensorFault = vs[1] == 0 ? t('Normal') : t('Fault')
            CabinetHighHumAlarm = vs[2] == 0 ? t('Normal') : t('Alarm')
            CabinetHighTempAlarm = vs[3] == 0 ? t('Normal') : t('Alarm')
            CabinetLowTempAlarm = vs[4] == 0 ? t('Normal') : t('Alarm')
            HighPressureAlarm = vs[5] == 0 ? t('Normal') : t('Alarm')
            LackOrLeakageFluorine = vs[6] == 0 ? t('Normal') : t('Alarm')
            CompressorRelay = vs[7] == 0 ? t('Off') : t('On')
            HeatingRelay = vs[8] == 0 ? t('Off') : t('On')
            FanRelay = vs[9] == 0 ? t('Off') : t('On')
            VentilationRelay = vs[10] == 0 ? t('Off') : t('On')
            SystemOnOff = vs[11] == 0 ? t('Off') : t('On')
            
        }
        if(registerData) {  //只取前2个字
            if(registerData.length < 8) { //小于8个字符则补足8个
                registerData = registerData.padEnd(8, '0');
            } else if(registerData.length > 8) {  //大于8个字符则取前8个
                registerData = registerData.slice(0, 8);
            }
            //将hex字符串转换为bit串
            const bits = registerData.split('').map(v => Number('0x' + v).toString(2).padStart(4, '0')).join('')  
            //将bit的串按双字节分割为数组
            const bytes = bits.match(/(.{16})/g);
            //对bytes的每个字进行处理
            const vs = bytes.map(v => {
                v = parseInt(v, 2)
                if(v > 0x7fff) {
                    v -= 0xffff + 1
                }
                return v;
            })
            CabinetTemperature = vs[0];
            CabinetHumidity = vs[1];
        }
    }

    return (
        <div style={{padding: '10px 15px'}}>
            <TitleBar title={t('Air-Conditioner')} data={data} />
            <div style={{marginTop: '20px'}}>
                <div style={{backgroundColor: '#f0f0f0', width: '100%',height: '270px', borderRadius: '10px',  padding: '4px 4px'}}>
                    <div>
                        <div style={{fontSize: '9px'}}>{t('Evaporator Sensor Fault')}: {EvaporatorSensorFault}</div>
                        <div style={{fontSize: '9px'}}>{t('Cabinet TempAndHum Sensor Fault')}: {CabTempHumSensorFault}</div>
                        <div style={{fontSize: '9px'}}>{t('Cabinet HighHum Alarm')}: {CabinetHighHumAlarm}</div>
                        <div style={{fontSize: '9px'}}>{t('Cabinet HighTemp Alarm')}: {CabinetHighTempAlarm}</div>
                        <div style={{fontSize: '9px'}}>{t('Cabinet LowTemp Alarm')}: {CabinetLowTempAlarm}</div>
                        <div style={{fontSize: '9px'}}>{t('High Pressure Alarm')}: {HighPressureAlarm}</div>
                        <div style={{fontSize: '9px'}}>{t('LackOrLeakage Fluorine')}: {LackOrLeakageFluorine}</div>
                        <div style={{fontSize: '9px'}}>{t('Compressor Relay')}: {CompressorRelay}</div>
                        <div style={{fontSize: '9px'}}>{t('Heating Relay')}: {HeatingRelay}</div>
                        <div style={{fontSize: '9px'}}>{t('Fan Relay')}: {FanRelay}</div>
                        <div style={{fontSize: '9px'}}>{t('Ventilation Relay')}: {VentilationRelay}</div>
                        <div style={{fontSize: '9px'}}>{t('System On/Off')}: {SystemOnOff}</div>
                        <div style={{fontSize: '9px'}}>{t('Cabinet Temperature')}: {CabinetTemperature}</div>
                        <div style={{fontSize: '9px'}}>{t('Cabinet Humidity')}: {CabinetHumidity}</div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default Air; 